import { Component, inject, Injector } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { FileUploadLauncherService } from '@modules/files/services/file-upload-launcher.service';
import { FileUploadSeedService } from '@modules/files/services/file-upload-seed.service';
import { FilesAppStateService } from '@modules/files/services/state.service';

import { type File } from '@modules/files/types/file';
import { Folder } from '@modules/files/types/folder';
import { ListState } from '@modules/files/types/list-state';

import { FullFormBaseComponent } from '@modules/common/components/full-form-base/full-form-base.component';
import { AbstractMainViewComponent } from '@modules/common/components/main-view/main-view.component';
import { getStitchInstanceByStitchType } from '@modules/common/utils/stitch';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'app-files-main-view',
  templateUrl: './files-main-view.component.html',
  styleUrls: ['./files-main-view.component.less'],
  standalone: false,
})
export class FilesMainViewComponent extends AbstractMainViewComponent<
  StitchType.FILE | StitchType.FOLDER,
  File | Folder,
  FullFormBaseComponent<StitchType.FILE | StitchType.FOLDER, File | Folder, Record<string, AbstractControl>>,
  ListState
> {
  protected override readonly stateService = inject(FilesAppStateService);
  private readonly fileUploadLauncher = inject(FileUploadLauncherService);
  private readonly fileUploadSeed = inject(FileUploadSeedService);
  private readonly injector = inject(Injector);

  /**
   * Type guards
   */

  asFile(item: File | Folder): File {
    return item as File;
  }

  asFolder(item: File | Folder): Folder {
    return item as Folder;
  }

  protected handleNewFile(): void {
    this.fileUploadLauncher.launch(this.fileUploadSeed.seed(this.injector), this.injector);
  }

  protected handleNewFolder(): void {
    this.openCreateModal(getStitchInstanceByStitchType(StitchType.FOLDER));
  }
}
